import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import config from 'config';

var EventCustomization = Backbone.Model.extend({

    defaults: {
        'agenda-view-type': 'list'
    },

    url: function() {
        return '/api/v1/events/' + this.get('id') + '/customization';
    },

    parse: function(response) {
        response.fetched = true;
        return response;
    }
});

export default EventCustomization;

